import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    table: {
      keyword: null,
      loading: false,
      total_items: 0,
      options: {},
      headers: [
        { title: Vuetify.locale.t('$vuetify.__QuestionTopic.keywords.title'), key: 'entity', width: '25%' },
        { title: Vuetify.locale.t('$vuetify.__AI.alias.title'), key: 'alias_str' },
        { title: '', key: 'action', sortable: false, width: 200 }
      ],
      items: []
    }
  },
  mutations: {
    SET_ALIAS_TABLE_KEYWORD(state, payload) {
      state.table.keyword = payload
    },
    SET_ALIAS_TABLE_LOADING(state, payload) {
      state.table.loading = payload
    },
    SET_ALIAS_TABLE_OPTIONS(state, payload) {
      state.table.options = payload
    },
    SET_ALIAS_TABLE_OPTIONS_PAGE(state, payload) {
      state.table.options.page = payload
    },
    SET_ALIAS_TABLE_ITEMS(state, payload) {
      state.table.items = payload
    },
    SET_ALIAS_TABLE_TOTAL_ITEMS(state, payload) {
      state.table.total_items = payload
    }
  },
  actions: {
    async fetchEntityList({ state, commit }) {
      try {
        commit('SET_ALIAS_TABLE_LOADING', true)
        commit('SET_ALIAS_TABLE_ITEMS', [])

        const keyword = state.table.keyword
        const page = state.table.options.page
        const itemsPerPage = state.table.options.itemsPerPage
        const sortBy = state.table.options?.sortBy[0] ? state.table.options.sortBy[0] : null
        let sort_by = null
        if (sortBy) {
          switch (sortBy.key) {
            case 'entity':
              sort_by = 'keyword'
              break
            case 'alias_str':
              sort_by = 'alias'
              break
          }
        }
        const order = sortBy ? sortBy.order : null

        const response = await api.getEntityList({ search: keyword, limit: itemsPerPage, offset: page * itemsPerPage - itemsPerPage, sort_by: sort_by, order: order })
        if (response.data.success) {
          commit('SET_ALIAS_TABLE_ITEMS', response.data.data)
          commit('SET_ALIAS_TABLE_TOTAL_ITEMS', response.data.total)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_ALIAS_TABLE_LOADING', false)
      }
    },
    async updateEntity({ commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.updating', ''), loading: true })
        const response = await api.updateEntity({ params: { entity_id: payload.entity_id, aliases: payload.alias_str.split(',') } })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.success', ''), icon: 'check', timeout: '2000' })
          dispatch('fetchEntityList')
          dispatch('searchAliasList')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    }
  }
}
